import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API_BASE });

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("inxpek_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Normaliza err.response.data.detail para SEMPRE ser uma string renderizável.
 * Preserva o objecto/array original em err.response.data.detailRaw para código
 * que precise de campos estruturados (ex.: detail.issues, detail.code).
 * Cobre:
 *   - string  → mantém
 *   - {message, code?, issues?} (HTTPException custom) → devolve message
 *   - Array<{loc, msg, type}> (validação Pydantic) → junta msgs
 *   - outros objectos → JSON.stringify (fallback defensivo)
 */
export function normalizeApiErrorDetail(detail) {
  if (detail == null) return detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) => {
        if (!d) return null;
        if (typeof d === "string") return d;
        if (typeof d === "object") return d.msg || d.message || null;
        return null;
      })
      .filter(Boolean);
    if (msgs.length) return msgs.join("; ");
    try { return JSON.stringify(detail); } catch { return "Erro de validação."; }
  }
  if (typeof detail === "object") {
    if (typeof detail.message === "string" && detail.message) return detail.message;
    if (typeof detail.msg === "string" && detail.msg) return detail.msg;
    if (typeof detail.error === "string" && detail.error) return detail.error;
    try { return JSON.stringify(detail); } catch { return "Erro."; }
  }
  return String(detail);
}

apiClient.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // token invalid/expired
      const isAdminRoute = typeof window !== "undefined" && window.location.pathname.startsWith("/admin");
      if (isAdminRoute && !window.location.pathname.endsWith("/login")) {
        localStorage.removeItem("inxpek_admin_token");
        localStorage.removeItem("inxpek_admin_user");
        window.location.href = "/admin/login";
      }
    }
    // Normaliza detail para evitar React error #31 ao passar objecto para toast/JSX
    try {
      if (err?.response?.data && Object.prototype.hasOwnProperty.call(err.response.data, "detail")) {
        const raw = err.response.data.detail;
        if (raw && typeof raw !== "string") {
          err.response.data.detailRaw = raw;
          err.response.data.detail = normalizeApiErrorDetail(raw);
        }
      }
    } catch (_) { /* noop */ }
    return Promise.reject(err);
  }
);

export default apiClient;
